<template>
  <v-list-item v-if="!item.loading" v-on="hasClickListener ? { click: () => $emit('click') } : {}">
    <slot name="icon"></slot>
    <v-list-item-content>
      <v-list-item-subtitle v-if="!small" class="text-xs">
        <tooltip v-if="!hasActionListener" :text="item.statusReadable">
          <v-avatar class="mr-1 white--text" :color="item.statusColor" :elevation="0" size="8" />
        </tooltip>
        <v-chip v-if="item.subTotal" x-small>
          {{ formatCurrency(item.subTotal, item.currency) }}
        </v-chip>
        <v-chip v-else x-small>
          {{ formatCurrency(0, item.currency) }}
        </v-chip>
        <v-chip v-if="item.date && item.isOverdue" color="error" x-small>
          {{ item.date | simpleDoubleDigitDate }}
        </v-chip>
      </v-list-item-subtitle>

      <v-list-item-title>
        <a v-if="hasOpenDetailListener" @click.stop="emitOpenDetail">
          {{ item.number }}
        </a>
        <span v-else> {{ item.number }} </span>
      </v-list-item-title>

      <v-list-item-subtitle v-if="!small">
        <span v-if="item.seller"> {{ $t("objects.repairEstimate.seller") }} {{ item.seller.name }} </span>
        <span v-if="item.buyer"> {{ $t("objects.repairEstimate.buyer") }} {{ item.buyer.name }} </span>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
  <v-skeleton-loader v-else type="list-item-three-line" />
</template>

<script lang="ts">
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";
import { formatCurrency } from "@/lib/utility/currency-helper";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefsRepairEstimate extends BaseRef<IRepairEstimate> implements IRefDetail<IRepairEstimate> {
  readonly RefsTypeMap = RefTypeMap;
  readonly formatCurrency = formatCurrency;

  @Prop()
  item!: IRepairEstimate;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  goToDetail() {
    this.item.goTo(this.$router).detail();
  }

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }
}
</script>
